import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'movie-index',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-index.vue')
    },
    {
      path: '/city',
      name: 'city',
      meta: {
        title: ''
      },
      component: () => import('../components/city.vue')
    },
    {
      path: '/orderstatus',
      name: 'movie-orderstatus',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-orderstatus.vue')
    },
    {
      path: '/movieHomePage',
      name: 'movieHomePage',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-home.vue')
    },
    // {
    //   path: '/seat',
    //   name: 'movie-seat',
    //   meta: {
    //     title: '电影选座'
    //   },
    //   component: () => import('../components/movie-seat.vue')
    // },
    {
      path: '/seat',
      name: 'movie-seat',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-seat2.vue')
    },
    {
      path: '/paydone',
      name: 'movie-payok',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-payok.vue')
    },
    {
      path: '/movieSettlement',
      name: 'movieSettlement',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-settlement.vue')
    },
    {
      path: '/movieIntroduce',
      name: 'movieIntroduce',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-introduce.vue')
    },
    {
      path: '/moviePosition',
      name: 'moviePosition',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-position.vue')
    },
    {
      path: '/cinemaDetail',
      name: 'cinemaDetail',
      meta: {
        title: ''
      },
      component: () => import('../components/cinema-detail.vue')
    },
    {
      path: '/orderList',
      name: 'orderList',
      meta: {
        title: ''
      },
      component: () => import('../components/movie-order-list.vue')
    },
    {
      path: '/searchPage',
      name: 'searchPage',
      meta: {
        title: ''
      },
      component: () => import('../components/search-page.vue')
    },
    {
      path: '/integralPage',
      name: 'integralPage',
      meta: {
        title: ''
      },
      component: () => import('../components/integralPage.vue')
    },
    {
      path: '/integralDetail',
      name: 'integralDetail',
      meta: {
        title: '积分账单明细'
      },
      component: () => import('../components/integralDetail.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js